import { render, staticRenderFns } from "./SyncView.vue?vue&type=template&id=c2b53ea8&scoped=true"
import script from "./SyncView.vue?vue&type=script&lang=js"
export * from "./SyncView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b53ea8",
  null
  
)

export default component.exports